export const CONTACT_ROLES = [
  { key: "banco_comprador", label: "Gestor do banco do comprador", short: "Banco do comprador", type: "banco" },
  { key: "banco_vendedor", label: "Gestor do banco do proprietário", short: "Banco do proprietário", type: "banco" },
  { key: "avaliador", label: "Avaliador bancário", short: "Avaliador", type: "avaliador" },
  { key: "condominio", label: "Administração do condomínio", short: "Condomínio", type: "condominio" },
  { key: "solicitador", label: "Solicitador/Notário", short: "Solicitador/Notário", type: "solicitador" },
  { key: "intermediario", label: "Intermediário de crédito", short: "Intermediário de crédito", type: "intermediario", optional: true },
  { key: "fotografo", label: "Fotógrafo / vídeo", short: "Fotógrafo", type: "fotografo", optional: true },
  { key: "planta", label: "Desenhador da planta", short: "Planta", type: "planta", optional: true },
  { key: "home_staging", label: "Home staging", short: "Home staging", type: "home_staging", optional: true },
  { key: "perito_ce", label: "Perito do certificado energético", short: "Perito CE", type: "perito_ce", optional: true },
];
export const ROLE_BY_KEY = Object.fromEntries(CONTACT_ROLES.map((r) => [r.key, r]));
export const CONTACT_TYPES = {
  banco: "Banco", avaliador: "Avaliador", condominio: "Condomínio",
  solicitador: "Solicitador/Notário", intermediario: "Intermediário de crédito",
  fotografo: "Fotógrafo / vídeo / drone / tour 3D", planta: "Planta (desenhador)",
  home_staging: "Home staging", perito_ce: "Perito do certificado energético",
};
export const CONTACT_GROUPS = [
  { label: "Venda e escritura", types: ["banco", "avaliador", "condominio", "solicitador", "intermediario"] },
  { label: "Preparação do imóvel", types: ["fotografo", "planta", "home_staging", "perito_ce"] },
];
export const CONTACT_PURPOSE = {
  fotografo: "Fotos e media", planta: "Planta do imóvel", home_staging: "Preparar o imóvel",
  perito_ce: "Se não houver certificado. É obrigatório antes de anunciar.",
};
export const ENTITY_HINT = {
  banco: "ex.: Caixa Geral de Depósitos", avaliador: "Empresa de avaliação", condominio: "Empresa de administração",
  solicitador: "Cartório ou escritório", intermediario: "Empresa de intermediação",
  fotografo: "Empresa ou nome artístico", planta: "Gabinete ou nome", home_staging: "Empresa de home staging",
  perito_ce: "Empresa de certificação",
};
export const hasContact = (c) => !!(c && (c.phone || c.email));
export const waUrl = (phone) => `https://wa.me/${(phone || "").replace(/\D/g, "").replace(/^(9\d{8})$/, "351$1")}`;
export const contactLine = (c) => [c.name, c.entity, c.phone, c.email].filter(Boolean).join(" · ");
export const linkSent = (lk) => !!(lk && (lk.last_access_at || (lk.sends || []).some((s) => s.channel !== "consultor")));
// Comprador: a página só conta depois de o consultor a enviar (vendedor: sempre).
export const counts = (role, lk) => role !== "comprador" || linkSent(lk);
